// Tiptap bundle - Rich text editor
import { Editor } from '@tiptap/core'
import StarterKit from '@tiptap/starter-kit'
import Link from '@tiptap/extension-link'
import Image from '@tiptap/extension-image'
import Placeholder from '@tiptap/extension-placeholder'

// Make Tiptap available globally
window.Tiptap = {
  Editor,
  StarterKit,
  Link,
  Image,
  Placeholder
} 